export const DuplicateIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19.5 20H6.5C6.1 20 5.75 19.85 5.45 19.55C5.15 19.25 5 18.9 5 18.5V2.5C5 2.1 5.15 1.75 5.45 1.45C5.75 1.15 6.1 1 6.5 1H15.2L21 6.8V18.5C21 18.9 20.85 19.25 20.55 19.55C20.25 19.85 19.9 20 19.5 20ZM14.45 7.45V2.5H6.5V18.5H19.5V7.45H14.45ZM3.5 23C3.1 23 2.75 22.85 2.45 22.55C2.15 22.25 2 21.9 2 21.5V6.025H3.5V21.5H15.95V23H3.5Z"
      fill="#999999"
    />
  </svg>
);
